const breakpoints = ["41em", "71em"];

export default breakpoints;
